import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    empleados: `${API_BASE}/Empleados`,
    empleadosById: (id) => `${API_BASE}/Empleados/${id}`,
    turnos: `${API_BASE}/Turnos`,
    turnosById: (id) => `${API_BASE}/Turnos/${id}`,
    turnoById: (id) => `${API_BASE}/Turnos/${id}`,
    empleadosTurnos: `${API_BASE}/EmpleadosTurnos`,
    empleadosTurnosById: (id) => `${API_BASE}/EmpleadosTurnos/${id}`,
    puestos: `${API_BASE}/Puestos`,
    puestosById: (id) => `${API_BASE}/Puestos/${id}`,
    areaNegocio: `${API_BASE}/AreaNegocio`,
    areaNegocioById: (id) => `${API_BASE}/AreaNegocio/${id}`,
    nivelJerarquico: `${API_BASE}/NivelJerarquico`,
    nivelJerarquicoById: (id) => `${API_BASE}/NivelJerarquico/${id}`,
    zonasGeograficas: `${API_BASE}/ZonasGeograficas`,
    zonasGeograficasById: (id) => `${API_BASE}/ZonasGeograficas/${id}`,
};
